// extracted by mini-css-extract-plugin
module.exports = {"smallLoader":"a-z","loader":"b-z","loading-keyframes":"c-z","pageLoader":"d-z","centered":"e-z","whitespacePlaceholder":"f-z","buttonSpinner":"g-z","fade-in":"h-z","rotate":"i-z"};